import { defineStore } from "pinia";
import { useAxios } from "@/composables/api.js";
import { catchError } from "@/composables/error.js";

export const useImageStore = defineStore("image", () => {
  async function uploadImage(company_id, type, image) {
    try {
      const { data } = await useAxios.post(
        `/companies/${company_id}/images/${type}`,
        {
          image,
        }
      );

      return data.image;
    } catch (error) {
      return catchError(error);
    }
  }

  return {
    uploadImage,
  };
});
